// Fonction pour animer l'élément
function toggleAnimation() {
    const element = document.querySelector('.track-bottom');
    // Vérifiez si l'élément est déjà animé
    if (element.classList.contains('animated')) {
        // Animer pour revenir à la position initiale
        gsap.to('.track-bottom', {
            y: '100%', // Utilisez 'y' au lieu de 'translateY' pour GSAP
            ease: 'expo.out',
            duration: 1 // Durée en secondes
        });
        element.classList.remove('animated');
    } else {
        // Animer pour déplacer l'élément
        gsap.to('.track-bottom', {
            y: '0%',
            ease: 'expo.out',
            duration: 1
        });
        element.classList.add('animated');
    }
}

// Ajouter un écouteur d'événements sur le bouton
document.getElementById('play').addEventListener('click', toggleAnimation);
